import {
    CREATE_FIELD,
    UPDATE_FIELD,
} from "../actions";

const field = (state = [], action) => {
    switch (action.type) {
    case CREATE_FIELD:
        return {
            id: action.id,
            value: action.value,
            label: action.label,
            valid: action.valid,
            stepId: action.stepId,
        };
    case UPDATE_FIELD:
        return (state.id === action.id)
            ? { ...state, value: action.value, valid: action.valid }
            : state;
    default:
        return state
    }
}

const fields = (state = [], action) => {
    switch (action.type) {
    case CREATE_FIELD:
        if (state.some(_field => _field.id === action.id)) {
            return state;
        }

        return [
            ...state,
            field(undefined, action)
        ];
    case UPDATE_FIELD:
        return state.map((_user) => field(_user, action));
    default:
        return state;
    }
};

export default fields;